import React, { FC, memo } from 'react';

import { useFavorite } from '@keaze/web/hooks/useFavorite';
import {
  StyledActions,
  FavoriteButton,
  FavoriteIconButton,
  StyledSkeleton,
} from './actions.styles';
import { ActionsProps } from './actions.types';

export const Actions: FC<ActionsProps> = memo(
  ({
    listingId,
    listingSlug,
    listingSchemes,
    favourite,
    isLoading = false,
    className,
  }) => {
    const { favorite, onFavoriteClick } = useFavorite({
      listingId,
      listingSlug,
      listingSchemes,
      favourite,
    });
    const title = favorite ? 'Saved' : 'Save';

    if (isLoading) {
      return (
        <StyledActions className={className}>
          <StyledSkeleton variant="rect" width={44} height={48} />
        </StyledActions>
      );
    }

    return (
      <StyledActions className={className}>
      </StyledActions>
    );
  }
);
